import { gql } from '@apollo/client';

export const QUERY_HAIR_COLORS = gql`
  query hairColors {
    hairColors {
      id
      name
    }
  }
`;
